export default "__VITE_ASSET__DkwFduAY__"